import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import { getEventById } from "../../redux/eventManagementSlice";

const OrganizerProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { eventId } = useParams();
  const { profile } = useSelector((state) => state.auth);
  const { managingEvent, managingEventStatus } = useSelector(
    (state) => state.eventManagement
  );

  useEffect(() => {
    if (eventId && profile._id) {
      dispatch(getEventById(eventId));
    }
  }, [eventId, profile._id, dispatch]);

  if (managingEventStatus === "idle" || managingEventStatus === "loading") {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100dvh",
          width: "100%",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (
    managingEventStatus === "failed" ||
    managingEvent.authorID !== profile._id
  ) {
    return <Navigate to="/feeds" replace />;
  }
  return children;
};

export default OrganizerProtectedRoute;
